module.exports = __webpack_public_path__ + "static/media/paper-free.dc0bbe5c.svg";